<script>
import Constants from "@/constants";
import {handleLoginResponse} from "@/util";

export default {
  name: "LoginOIDC",
  expose: [],
  components: {},
  props: {},
  data()
  {
    return {
      errorMessage: "",
      logo: "/img/logo-dark-theme.png",
      appTitle: process.env.VUE_APP_TITLE,
    }
  },
  async mounted()
  {
    try
    {
      const urlParams = new URLSearchParams(window.location.search);

      const code = urlParams.get('code') ?? '';
      const state = urlParams.get('state') ?? '';
      const error = urlParams.get('error') ?? '';

      const challenge = localStorage.getItem(Constants.localStorageKeyLoginChallenge) ?? '-';

      if
      (
          !code
          ||
          (!state || localStorage.getItem(Constants.localStorageKeyLoginState) !== state)
          ||
          (error && error.length > 0)
      )
      {
        console.error(`OIDC/SSO Sign-In Failed. State parameter mismatch or no code (or wrong code) parameter provided by IdP redirection.`);
        throw new Error('Authentication failed');
      }

      const tokenResponse = await fetch(`${process.env.VUE_APP_OIDC_AUTHORITY_BASE_URL}/realms/glitchedpolygons/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          'client_id': process.env.VUE_APP_OIDC_CLIENT_ID,
          'grant_type': 'authorization_code',
          'code': code,
          'code_verifier': challenge,
          'redirect_uri': process.env.VUE_APP_OIDC_REDIRECT_URI,
          'scope': 'openid profile email'
        })
      });

      if (!tokenResponse.ok)
      {
        throw new Error('Authentication failed');
      }

      const tokenResponseBody = await tokenResponse.json();

      const accessToken = tokenResponseBody.access_token;
      const refreshToken = tokenResponseBody.refresh_token;

      const loginResponse = await fetch(`${process.env.VUE_APP_WEB_API_BASE_URL}/api/v1/login/oidc`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${accessToken}`,
        }
      });

      if (!loginResponse || !loginResponse.ok)
      {
        throw new Error('Authentication failed');
      }

      const loginResponseEnvelope = await loginResponse.json();

      if (!loginResponseEnvelope.items || loginResponseEnvelope.items.length !== 1 || loginResponseEnvelope.type !== 'LoginResponseDto')
      {
        throw new Error('Authentication failed');
      }
      else
      {
        const rememberMe = localStorage.getItem(Constants.localStorageKeyRememberMe);

        localStorage.removeItem(Constants.localStorageKeyRememberMe);

        handleLoginResponse(loginResponseEnvelope.items[0], rememberMe?.toLowerCase() === 'true', this.$router);
      }
    }
    catch (e)
    {
      localStorage.removeItem(Constants.localStorageKeyRememberMe);

      this.errorMessage = e.toString()
    }
  }
}
</script>

<template>

  <div class="container">

    <div class="login-title">

      <img id="logo"
           alt="Logo"
           width="128"
           height="128"
           :src="logo">

      <h1>
        Welcome to the <span style="white-space: nowrap;">{{ appTitle }}</span>
      </h1>

      <h2 v-if="errorMessage && errorMessage.length > 0">
        {{ errorMessage }}
      </h2>

      <h2 v-else>
        Logging in...
      </h2>

    </div>

  </div>

</template>

<style scoped>

#logo {
  margin-top: 64px;
}

.login-title {
  text-align: center;
}

</style>